import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import Image from 'react-bootstrap/Image';
import erreur404 from '../image/erreur404.gif';


export default function NotPageFound() {
  const location = useLocation();

  return (
    <div className='notpagefound'>
      <div>
        <Image className='px-2' src={erreur404} rounded alt="erreur page 404" />
      </div>
      <h2>Ho, Ho... il semblerait que vous soyez perdu...</h2>
      <h5>
        Aucune adresse enregistrée pour: <code>{location.pathname}</code>
      </h5>
      <br />
      <h4>
        <Link to='/' className='notfound'>Revenir à l'accueil</Link>
      </h4>
    </div>
  );
}